module.exports = __webpack_public_path__ + "img/IMG_1164.cfdacda4.jpg";